import { render, staticRenderFns } from "./MyDataRightsForm.vue?vue&type=template&id=284e3328&scoped=true"
import script from "./MyDataRightsForm.vue?vue&type=script&lang=js"
export * from "./MyDataRightsForm.vue?vue&type=script&lang=js"
import style0 from "./MyDataRightsForm.vue?vue&type=style&index=0&id=284e3328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e3328",
  null
  
)

export default component.exports